import {graphql} from 'gatsby';
import React, {FC} from 'react';

import {
  ImageTextXSCentered,
  DynamicImageTextXSCenteredProps
} from '../../../components/modules/imageTextBlocks/xsCentered';

import {
  ImageTextXSCentered as ImageTextXSCenteredR4,
  Size as ImageTextXSCenteredR4SizeProp,
  DynamicImageTextXSCenteredR4Props
} from '../../../components/modules/imageTextBlocks/xsCenteredR4';

import {ImageTextXSGrid} from '../../../components/modules/imageTextBlocks/xsGrid';
import {
  ImageTextXSGridR4,
  DynamicImageTextXSGridR4Props
} from '../../../components/modules/imageTextBlocks/xsGridR4';
import {IconName} from '../../../components/molecules/icon';
import {ImageTextXsFragment} from '../../../lib/queryTypes';
import {useTranslation} from '../../../context/translation';
import {paletteR4} from '../../../lib/styleVariablesR4';
import {transformFluidProps} from '../image';

export const ImageTextXS: FC<ImageTextXsFragment &
  DynamicImageTextXSCenteredProps &
  DynamicImageTextXSCenteredR4Props &
  DynamicImageTextXSGridR4Props> = props => {
    const {t} = useTranslation();
    const {designVersion} = props;
    switch (props.type?.toLowerCase()) {
      case 'centered': {
        if (designVersion === 'r4')
          return (
            <ImageTextXSCenteredR4
              size={(props.size! as ImageTextXSCenteredR4SizeProp) || 'small'}
              title={props.title!}
              description={props.description!}
              itemPosition={props.itemPosition?.toLowerCase() === 'top' ? 'top' : 'bottom'}
              items={
              props.items?.map(item => ({
                description: item?.content!,
                imgSrc: item?.image?.fluid ? transformFluidProps(item.image.fluid) : undefined,
                iconName: item?.iconName! as IconName,
                title: item?.title!,
                buttonLink: item?.buttonLink!,
                buttonText: item?.buttonText!
              })) || []
              }
              accentColor={props.accentColor}
              imgSize={props.imgSize}
              itemsPerRow={props.itemsPerRow}
              withSliderOnMobile={props.withSliderOnMobile}
            />
          );

        return (
          <ImageTextXSCentered
            title={props.title!}
            // @ts-ignore
            items={props.items?.map(item => ({
              size: 'xs',
              iconName: item?.iconName! as IconName,
              iconBackgroundColor: item?.iconColor!,
              title: item?.title!,
              description: item?.content
            }))}
            itemsPerRow={props.itemsPerRow!}
            rowMargin={props.rowMargin!}
          />
        );
      }
      case 'grid':
        if (designVersion === 'r4')
          return (
            <ImageTextXSGridR4
              title={props.title!}
              // @ts-ignore
              items={props.items?.map(item => ({
                title: item?.title || '',
                size: 'xs',
                iconName: item?.iconName as IconName,
                iconBackgroundColor: paletteR4.white.base,
                description: item?.content,
                linkHref: item?.buttonLink,
                linkText: item?.buttonText,
                designVersion: 'r4'
              }))}
              accentColor={props.accentColor}
              direction={props.direction}
              withSliderOnMobile={props.withSliderOnMobile}
            />
          );

        return (
          <ImageTextXSGrid
            showMoreText={t('common.show-more')}
            // @ts-ignore
            items={props.items?.map(item => ({
              title: item?.title || '',
              size: 'xs',
              iconName: 'checkmarkCircle' as IconName,
              description: item?.content
            }))}
          />
        );
      default:
        return null;
    }
  };

export const query = graphql`
  fragment ImageTextXS on ContentfulModulesImageTextXs {
    title
    type
    designVersion
    size
    description
    itemPosition

    items {
      image {
        ...ImageContentfulSmallFluid
      }
      content
      iconColor
      iconName
      title
      buttonText
      buttonLink
      content
    }
  }
`;
